import { render, staticRenderFns } from "./ItsColdStorageFee.vue?vue&type=template&id=d9abad8c&scoped=true&"
import script from "./ItsColdStorageFee.vue?vue&type=script&lang=js&"
export * from "./ItsColdStorageFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9abad8c",
  null
  
)

export default component.exports